import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from '@Integrations/Datasets/queries-core'
import { isRef, ref, Ref } from 'vue'
export function useDatasetChangeLogQueryV1(datasetId?: string | Ref<string>, ) {
	const _datasetId = isRef<string>(datasetId) ? datasetId : ref<string>(datasetId)
	const result = {
		datasetId: _datasetId,
		...useQuery(() => new q.DatasetChangeLogQueryV1(_datasetId.value))
	}
	return {
		...result,
		runDatasetChangeLogQueryV1: result.run,
		modelDatasetChangeLogQueryV1: result.model,
	}
}

export function useDatasetDetailsQueryV1(datasetId?: string | Ref<string>, ) {
	const _datasetId = isRef<string>(datasetId) ? datasetId : ref<string>(datasetId)
	const result = {
		datasetId: _datasetId,
		...useQuery(() => new q.DatasetDetailsQueryV1(_datasetId.value))
	}
	return {
		...result,
		runDatasetDetailsQueryV1: result.run,
		modelDatasetDetailsQueryV1: result.model,
	}
}

export function useDatasetPropertyNamesQueryV1(datasetId?: string | Ref<string>, ) {
	const _datasetId = isRef<string>(datasetId) ? datasetId : ref<string>(datasetId)
	const result = {
		datasetId: _datasetId,
		...useQuery(() => new q.DatasetPropertyNamesQueryV1(_datasetId.value))
	}
	return {
		...result,
		runDatasetPropertyNamesQueryV1: result.run,
		modelDatasetPropertyNamesQueryV1: result.model,
	}
}

export function useDatasetsOfOrganizationQueryV1(organizationUnitId?: string | Ref<string>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.DatasetsOfOrganizationQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runDatasetsOfOrganizationQueryV1: result.run,
		modelDatasetsOfOrganizationQueryV1: result.model,
	}
}

